module.exports = __webpack_public_path__ + "static/benefit-1-0478be471a9ccf2373a7f56c3e753978.svg";